export default __webpack_public_path__ + "static/media/the-crew.59e3efcb.jpg";